const KEYS = new Set(["surface", "sku", "plan", "count", "state", "route"]);
const DIGITS = /\d{6,}/;
const DIAL = /(^|\s)\+\d/;
function clean(value) {
  if (value === null || value === undefined) return "";
  const text = String(value).trim();
  if (!text) return "";
  if (text.includes("@")) return "";
  if (DIGITS.test(text)) return "";
  if (DIAL.test(text)) return "";
  return text.slice(0, 48);
}
function clarity() {
  return typeof window.clarity === "function" ? window.clarity : null;
}
function track(name, props) {
  const c = clarity();
  if (!c) return;
  const event = clean(name);
  if (!event) return;
  try {
    c("event", event);
    if (!props) return;
    for (const key of Object.keys(props)) {
      if (!KEYS.has(key)) continue;
      const value = clean(props[key]);
      if (!value) continue;
      c("set", key, value);
    }
  } catch (err) {
  }
}
const once = new Set();
function first(key, name, props) {
  if (once.has(key)) return;
  once.add(key);
  track(name, props);
}
const doc = document;
function surfaceOf(form) {
  if (!form) return "";
  if (form.hasAttribute("data-xg-pair-all")) return "bundle";
  if (form.hasAttribute("data-xg-guard-add")) return "protection";
  if (form.closest(PDP_ROOT)) return "pdp";
  if (form.closest("#xg-cart-drawer")) return "drawer";
  if (form.closest("[data-xg-cart-region]")) return "cart";
  return "page";
}
const PDP_ROOT = "[data-xg-pdp-mode]";
function activeSku() {
  const root = doc.querySelector(PDP_ROOT);
  return root ? root.getAttribute("data-xg-active") || "" : "";
}
doc.addEventListener("submit", (event) => {
  const form = event.target.closest && event.target.closest("form[data-xg-cart-add]");
  if (!form) return;
  if (form.hasAttribute("data-xg-pair-all")) {
    const posting = form.querySelectorAll('input[name="items[][id]"]:not([disabled])');
    track("bundle_add_all", { count: String(posting.length) });
    return;
  }
  track("add_to_cart_intent", { surface: surfaceOf(form), sku: activeSku() });
});
doc.addEventListener("xg:cart:added", (event) => {
  const detail = (event && event.detail) || {};
  track("add_to_cart", { surface: surfaceOf(detail.form), sku: activeSku() });
});
doc.addEventListener("click", (event) => {
  if (!event.target.closest) return;
  if (event.target.closest("[data-xg-cart-checkout]")) {
    track("begin_checkout", { surface: surfaceOf(event.target.closest("form")) });
  }
});
doc.addEventListener("xg:drawer:open", (event) => {
  const id = event.target && event.target.id;
  if (id === "xg-cart-drawer") track("cart_drawer_open");
  else if (id === "xg-nav-drawer") track("nav_drawer_open");
});
doc.addEventListener("change", (event) => {
  const input = event.target.closest && event.target.closest('input[name="selling_plan"]');
  if (!input) return;
  track("plan_selected", {
    plan: input.value ? "subscription" : "one_time",
    sku: activeSku()
  });
});
doc.addEventListener("xg:pdp:select", (event) => {
  const detail = (event && event.detail) || {};
  track("sku_swap", { sku: clean(detail.sku) });
});
doc.addEventListener(
  "toggle",
  (event) => {
    const el = event.target;
    if (!el || el.tagName !== "DETAILS" || !el.open) return;
    if (el.closest("[data-xg-len]")) {
      track("review_expand", { sku: activeSku() });
      return;
    }
    if (el.hasAttribute("data-xg-coa-explain")) {
      track("coa_explainer_open", { sku: activeSku() });
    }
  },
  true
);
function watchCoa() {
  const table = doc.querySelector('[data-slot="coaTable"]:not([hidden])');
  if (!table || typeof IntersectionObserver !== "function") return;
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        io.disconnect();
        first("coa", "coa_table_view", { sku: activeSku() });
        return;
      }
    },
    { threshold: 0.4 }
  );
  io.observe(table);
}
doc.addEventListener("focusin", (event) => {
  const input = event.target.closest && event.target.closest("[data-xg-spec-input]");
  if (input) first("spec", "specialist_open");
});
doc.addEventListener("submit", (event) => {
  const form = event.target.closest && event.target.closest("[data-xg-spec-form]");
  if (form) track("specialist_ask");
});
function init() {
  watchCoa();
}
if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", init);
else init();
doc.addEventListener("shopify:section:load", init);
window.XG = window.XG || {};
window.XG.track = track;
